var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Database {
    constructor(context, dbId) {
        this.context = context;
        this.dbId = dbId;
    }
    execute(statement, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.context.callNative("sqlite", "execute", {
                statement,
                parameters: parameters || [],
                dbId: this.dbId,
            });
        });
    }
    executeQuery(statement, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.context.callNative("sqlite", "executeQuery", {
                statement,
                parameters: parameters || [],
                dbId: this.dbId,
            }));
        });
    }
    executeUpdateDelete(statement, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.context.callNative("sqlite", "executeUpdateDelete", {
                statement,
                parameters: parameters || [],
                dbId: this.dbId,
            }));
        });
    }
    executeInsert(statement, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.context.callNative("sqlite", "executeInsert", {
                statement,
                parameters: parameters || [],
                dbId: this.dbId,
            }));
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.context.callNative("sqlite", "close", {
                dbId: this.dbId,
            });
        });
    }
    static open(context, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            const dbId = (yield context.callNative("sqlite", "open", {
                fileName,
            }));
            return new Database(context, dbId);
        });
    }
}
//# sourceMappingURL=SQLite.js.map